import { Columns, Skeleton } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { Spacer } from "@aviary";
import SignInAppTestDesktop from "@shared/assets/signin-asset.png";
import { SkeletonGoogleSSOButton } from "@shared/components/LoginOptions/GoogleSSOButton/SkeletonGoogleSSOButton";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { SkeletonSignInForm } from "@unauthenticated/shared/components/SignInForm/SkeletonSignInForm";
import { SignInWrapper } from "@unauthenticated/shared/components/SignInWrapper/SignInWrapper";
import { SignInLayout } from "@unauthenticated/signupSignin/components/SignInLayout/SignInLayout";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./SignInPage.styles";

const SkeletonSignInPage = () => {
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();
  const isMobile = !tablet.greaterThan;

  const renderSignInForm = () => (
    <SignInWrapper>
      <Skeleton type="typography" typographyType="h1" />
      <Spacer height="one" />
      <SkeletonGoogleSSOButton isOrTextRendered />
      <Spacer height="one" />
      <SkeletonSignInForm />
      <Spacer height="doubleHalf" />
      <Skeleton type="typography" typographyType="body" isFullWidth />
    </SignInWrapper>
  );

  const renderContent = () => {
    if (!isMobile) {
      return (
        <Columns>
          <Columns.Column columnWidth={6}>
            <div css={styles.centeredContentContainer}>
              <img
                src={SignInAppTestDesktop}
                alt={t(l.signIn.signInPage.appBannerAlt)}
                css={styles.bannerImage}
              />
            </div>
          </Columns.Column>
          <Columns.Column columnWidth={6}>
            <div css={styles.centeredContentContainer}>{renderSignInForm()}</div>
          </Columns.Column>
        </Columns>
      );
    }

    return renderSignInForm();
  };

  return <SignInLayout>{renderContent()}</SignInLayout>;
};

export { SkeletonSignInPage };
